import {
  AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit, QueryList, ViewChild,
  ViewChildren, ViewEncapsulation
} from '@angular/core';
import {Location} from '@angular/common';
import {Platform} from '../../../models/platform';
import {Campaign} from '../../../models/campaign';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {CampaignService} from '../../services/campaign/campaign.service';
import {TranslateService} from '@ngx-translate/core';
import {CampaignItemComponent} from './campaign-item/campaign-item.component';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {Subscription} from 'rxjs/Subscription';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {CampaignInfluencerStatus, CommonConstant} from '../../app.constants';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {AddInfluencersCampaign} from '../../../models/campaign/add-influencers-campaign';
import {InfluencerSuggestion} from '../../../models/influencer-suggestion';
import {
  ActionDetails,
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType,
} from '../../services/event-tracker/event-tracker.service';
import {CacheService} from '../../services/cache/cache.service';
import {InvalidAction} from '../../../models/user';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {EventFilter, EventFilterType, EventType} from '../../../models/user-notification';
import {Observable} from 'rxjs/Observable';
import {DateUtils} from '../../utils/date.utils';
import { Subject } from 'rxjs/Subject';
import { debounceTime, tap, switchMap, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { WebUtils } from '../../utils/web.utils';
import { StringUtils } from '../../utils/string.utils';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CampaignsComponent extends AbstractAchooComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChildren(CampaignItemComponent) _campaignItems: QueryList<CampaignItemComponent>;
  @ViewChild('WarningCampaignDialog') warningCampaignDialog: AchooPopupComponent;
  @ViewChild('AlertErrorWhenAddInfluencerToCampaign')
  public alertErrorWhenAddInfluencerToCampaign: AchooPopupComponent;
  @ViewChild('SearchCampaignErrorDialog') private _searchCampaignErrorDialog: AchooPopupComponent;

  public platformList: Platform[] = [];

  // this flag is used to show/hide bottom bar
  public isOpenBottomBar: boolean | false;
  // this flag use to show/hide add-influencer-to-campaign fragment
  public isShowAddInfluencerToCampaignsFragment: boolean | false;
  // this flag use to show/hide add-influencer-manually fragment
  public isShowAddInfluencerManuallyFragment: boolean | false;
  // the selected campaign
  public currentCampaign: Campaign | null;
  // the deleted campaign
  public campaignToDelete: Campaign;

  public searchCampaignList: Campaign[] = [];
  public invitesCampaignList: Campaign[] = [];
  public activesCampaignList: Campaign[] = [];
  public historiesCampaignList: Campaign[] = [];

  private campaignList;
  public errorMessage: string;
  // that use to store the list of influencer will be added to campaign
  public pendingInfluencerListAddToCampaign;
  // that use to cached the list of selected influencer will be added to campaign
  // use for add manually
  public selectedInfluencerToAddCampaign: InfluencerSuggestion[];
  public indexInfluencerManually: number;
  public processingInfluencerSuggestion: InfluencerSuggestion;
  public addInfluencerAsAccepted: boolean;

  public selectedCampaignId: number;
  // flag using to determine what platform is running
  public enableInfluencerPlatform: boolean;
  // flag using to check whether user is in campaign history page or not
  public isCampaignHistory: boolean;
  public numberOfLoadedCampaign: number;

  // search
  private _searchValueSubject: BehaviorSubject<string>;
  private _companyIdSubject: Subject<number>;
  private _searchSubscription: Subscription;
  public currentSearchValue = '';
  public isSearching: boolean;
  public isSearchResultEmpty: boolean;
  private _originalQueryParams: any;

  constructor(private campaignService: CampaignService,
              protected userService: UserService,
              private groupService: InfluencerGroupsService,
              private route: ActivatedRoute,
              private referenceDataService: ReferenceDataService,
              private translate: TranslateService,
              private modalService: ModalService,
              private eventTracker: EventTrackerService,
              private cacheService: CacheService,
              protected router: Router,
              private ngZone: NgZone,
              private _location: Location,
              private influencerService: InfluencerService,
              private placeholderService: PlaceholderVisibilityService) {
    super(userService);
    this.platformList = this.referenceDataService.platforms;
  }

  ngOnInit() {
    this.influencerService.cancelCurrentPreloadingRequest();
    this.numberOfLoadedCampaign = 0;
    let initialSearch = '';
    this.route.queryParams.subscribe(params => {
      this._originalQueryParams = params;
      this.selectedCampaignId = Number(params.selectedCampaign);

      if (params.search) {
        initialSearch = params.search;
      }
    });
    this.route.data.subscribe(data => {
      this.enableInfluencerPlatform = data.onInfluencerPlatform;
      const currentInfluencer = this.userService.getInfluencerInfo();
      if (this.enableInfluencerPlatform && currentInfluencer) {
        this.fetchCampaignBelongedToInfluencer(currentInfluencer.id);
      }
      this.isCampaignHistory = data.isCampaignHistory ? data.isCampaignHistory : false;
      if (this.isCampaignHistory) {
        this.trackViewEventForCampaignHistory();
      }
    });
    // Enable removing caching data.
    // to prevent reloading list when switching back and forth between active campaigns and campaign history.
    this.cacheService.enableCacheRemoving();

    // Just support search from query params for Advertiser app
    if (this.enableInfluencerPlatform) {
      initialSearch = '';
    }

    this.setupSearchSubcription(initialSearch);

    super.ngOnInit();
  }

  ngOnDestroy() {
    if (this._searchSubscription) {
      this._searchSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }

  companyChangeCallback(companyId) {
    if (!this.enableInfluencerPlatform) {
      this.triggerSearch();
      this.userService.updateLastViewTime(EventType.NEW_CAMPAIGN_POST, companyId);
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.cacheService.has('campaign_list_scroll_top')) {
        this.cacheService.get('campaign_list_scroll_top').subscribe((pos) => {
          window.scrollTo(0, pos);
        });
      }
    }, 100);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.ngZone.runOutsideAngular(() => {
      if (document.documentElement.scrollTop > 0) {
        this.cacheService.set('campaign_list_scroll_top', document.documentElement.scrollTop);
      }
    });
  }

  private trackViewEventForCampaignHistory() {
    this.eventTracker.trackUserAction(UserActionType.VIEW, undefined, undefined, undefined, undefined, {
        type: ActivePages.CAMPAIGN_HISTORY
      });
  }

  private fetchCampaignBelongedToInfluencer(influencerId) {
    let data = {
      influencer_id: influencerId,
      page: 1,
      page_size: 100
    };
    // advertiser should only get campaign which belonged to the active account
    if (!this.enableInfluencerPlatform) {
      data = Object.assign({}, data, {
        company_id: this.companyId
      });
    }
    this.influencerService.getCampaignListOfInfluencer(data).subscribe((res) => {
      const ignoredDeclinedCampaigns = res.filter(cp =>
        cp.campaignType === CampaignInfluencerStatus.ARCHIVED ||
        cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name.toLowerCase())
        .map((camp) => ({
          name: camp.name,
          id: camp.campaignId,
          campaignInfluencerId: camp.id,
          status: camp.status,
          campaignType: camp.campaignType,
          isFetchingKpi: true,
          key_search: camp.name.toLowerCase().replace(/[^a-z0-9]/g, '')
        }));
      this.campaignList = ignoredDeclinedCampaigns;
      this.searchCampaignList = ignoredDeclinedCampaigns;
      this.campaignList.forEach(campaign => {
        campaign.status = this.calculateCampaignStatus(campaign.status);
        this.fetchPostsOfInfluencerCampaign(campaign);
      });
      this.triggerClientSearch();
    });
  }

  private fetchPostsOfInfluencerCampaign(camp: Campaign) {
    this.influencerService.getCampaignInfluencerData(camp.campaignInfluencerId)
      .subscribe((res) => {
        // parse post list
        const postList = res.postList.map(post => ({
          imageUrl: post.image,
          title: post.page_title,
          date: post.date,
          relativePath: post.relativePath,
          fullUrl: post.full_url,
          platformBlogs: post.platformBlogs,
          platformInstagram: post.platformInstagram,
          platformYoutube: post.platformYoutube,
          platformSnapchat: post.platformSnapchat,
          platformTwitter: post.platformTwitter,
          platformPinterest: post.platformPinterest,
          platformFacebook: post.platformFacebook,
          reach: post.reach.value,
          engagement: post.engagement.value,
          impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
          impact: post.impact.value,
          urlHash: post.urlHash
        }));
        camp.posts = postList;
        camp.typeName = res.campaign.brief;
        this.campaignService.updateCampaignDetailsDataByPostList(camp);
      });
  }

  private calculateCampaignStatus(status) {
    const statusUppercase = `${status}`.toUpperCase();
    if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name
      || statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name) {
      return CampaignInfluencerStatus.NEW;
    } else if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
      return CampaignInfluencerStatus.DELETE;
    } else {
      return CampaignInfluencerStatus.ACTIVE;
    }
  }

  private runFetchInfluencersOfCampaignSerial(campaigns) {
    let result = Promise.resolve();
    campaigns.forEach(camp => {
      result = result.then(() => new Promise<void>((resolve, reject) => {
        this.cacheService.get(`campaign_influencers_${camp.id}`,
          this.campaignService.getInfluencerByCampaign(camp.id)).subscribe(res => {
          this.numberOfLoadedCampaign++;
          this.campaignService.updateCampaignDetailsData(camp, res);
          this.preloadInfluencerBelongToCampaign();
          resolve(null);
        }, (err) => {
          this.numberOfLoadedCampaign++;
          resolve(null);
        });
      }));
    });
  }

  private preloadInfluencerBelongToCampaign() {
    if (this.numberOfLoadedCampaign === this.campaignList.length) {
      const influencerList =  [];
      this.campaignList.forEach(c => {
        influencerList.push(...c.influencers);
      });
      this.influencerService.preloadCampaignInfluencerDataByIdList(influencerList, false);
    }
  }

  showAddInfluencerToCampaigns() {
    if (!this.currentCampaign) {
      return false;
    }
    // open fragment
    this.isShowAddInfluencerToCampaignsFragment = true;
    this.isOpenBottomBar = true;
  }

  showFragmentAddInfluencerManually(evt) {
    // clear pending influencer list
    this.pendingInfluencerListAddToCampaign = undefined;
    this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
    this.indexInfluencerManually = evt.processingIndex;
    this.processingInfluencerSuggestion = evt.influencerSuggestion;
    this.isShowAddInfluencerManuallyFragment = true;
    this.isShowAddInfluencerToCampaignsFragment = false;
    this.addInfluencerAsAccepted = evt.addInfluencerAsAccepted;
  }

  closeFragmentAddInfluencerManually(influencer?: InfluencerSuggestion) {
    if (influencer) {
      this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
    }
    this.processingInfluencerSuggestion = null;
    this.indexInfluencerManually = null;
    this.isShowAddInfluencerToCampaignsFragment = true;
    this.isShowAddInfluencerManuallyFragment = false;
  }

  addInfluencerToCampign(addInfluencerCampaign) {
    // close bottombar (Optimistic UI)
    this.closeAddInfluencerToCampaign({
      resetSelectedInfluencer: false
    });
    // hide previous notification
    this.modalService.close();
    // clear cached selected influencer suggestions
    this.selectedInfluencerToAddCampaign = [];
    // keep the list availabel influencers
    this.pendingInfluencerListAddToCampaign = addInfluencerCampaign.influencers;
    // normalize influencer list
    const newInfluencers = addInfluencerCampaign.influencers.map(influencer => ({
      domain: influencer.influencerName,
      influencer_id: influencer.influencerId,
      action: influencer.action,
      profile_image: influencer.profilePicture,
      status: influencer.status.toLowerCase()
    }));

    const data = new AddInfluencersCampaign();
    data.campaign_id = addInfluencerCampaign.campaign_id;
    data.influencers = newInfluencers;
    const infAddedAsAccepted = addInfluencerCampaign.influencers.filter(item => item.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name);
    // Call Api
    this.campaignService.addInfluencerToCampaign(data).subscribe((res: any) => {
      this.pendingInfluencerListAddToCampaign = undefined;
      this.reloadSelectedCampaign(addInfluencerCampaign.campaign_id);
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: this.currentCampaign.id,
        name: this.currentCampaign.name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        source: ActionSource.ACTION_VIEW,
        ...data
      }, undefined, {
        type: ActivePages.CAMPAIGN_OVERVIEW,
      });

      // Tracking cham event
      if (infAddedAsAccepted && infAddedAsAccepted.length === 0) {
        this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
      }

      // clean cached influencer list
      this.pendingInfluencerListAddToCampaign = [];

      this.userService.triggerUpdateActivatedInfluencers();
    }, (error) => {
      this.showAddInfluencerToCampaigns();
      if (error.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Campaign', error.error.message);
        this.sendInvalidActionToSegement(this.groupService.extractLimitInfoFromErrorMessage(error.error.message,
          data.influencers.length, this.userService.maxCampaignInfluencers, true), data);
      } else {
        this.errorMessage = error.error.message;
        this.modalService.open(this.alertErrorWhenAddInfluencerToCampaign, undefined, true);
      }
    });
  }

  private sendInvalidActionToSegement(limitInfo, influencerAddToCampaign) {
    const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
      limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);

    // send event when adding to Campaign
    this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
      id: this.currentCampaign.id,
      name: this.currentCampaign.name,
      type: TargetType.CAMPAIGN
    }, {
      action: UserActionType.UPDATE,
      actionDetails: ActionDetails.ADDED_INFLUENCERS,
      source: ActionSource.ACTION_VIEW,
      ...influencerAddToCampaign
    }, undefined, {
      type: ActivePages.CAMPAIGN_OVERVIEW,
    });
  }

  closeAddInfluencerToCampaign(data) {
    // clear up the previous influencers
    this.pendingInfluencerListAddToCampaign = undefined;
    if (data.resetSelectedInfluencer) {
      this.pendingInfluencerListAddToCampaign = [];
    }
    this.selectedInfluencerToAddCampaign = null;
    // close bottom bar
    this.isShowAddInfluencerToCampaignsFragment = false;
    this.isOpenBottomBar = false;
  }

  onSelectCampaign(campaign: any) {
    this.currentCampaign = (campaign.is_expanded) ? null : campaign;
    this.closeAddInfluencerToCampaign({
      resetSelectedInfluencer: true
    });
    this.searchCampaignList.forEach((campaignItem) => campaignItem.is_expanded = false);
  }

  showWarningDeleteCampaignPopup(campaign) {
    if (!campaign) {
      return;
    }
    this.modalService.openInCenter(this.warningCampaignDialog);
    this.campaignToDelete = campaign;
  }

  /**
   * When user accept to delete the campaign
   */
  acceptToDeleteCampaign() {
    // if current user is influencer, decline this campaign
    if (this.enableInfluencerPlatform) {
      this.declineCampaign(this.campaignToDelete.campaignInfluencerId);
    } else if (this.isCampaignHistory) {
      // if current user is company, delete this campagin
      this.deleteCampaign();
    } else {
      this.archiveCampaign(this.campaignToDelete);
    }
  }

  archiveCampaign(campaign: Campaign) {
    this.modalService.close();
    if (campaign && campaign.status !== CampaignInfluencerStatus.ACTIVE) {
      return;
    }
    // remove camapgin on UI immediately
    const deletedCampaignIndex = this.activesCampaignList.findIndex(c => c.id === campaign.id);
    this.activesCampaignList.splice(deletedCampaignIndex, 1);
    this.campaignService.archiveCampaign(campaign.id).subscribe(
      res => {
        campaign = null;
        this.userService.triggerUpdateActivatedInfluencers();
      },
      error => {
        // rollback delete campaign in previous position
        this.activesCampaignList.splice(deletedCampaignIndex, 0, campaign);
        // show error message
        this.errorMessage = this.translate.instant('campaigns.archive_error');
        this.modalService.open(this.alertErrorWhenAddInfluencerToCampaign, this.beforeClearErrorNotification.bind(this), true);
      }
    );
  }

  deleteCampaign() {
    this.closeWarningDeleteICampaignPopup();
    const campaignId = this.campaignToDelete.id;
    // remove camapgin on UI immediately
    const deletedCampaignIndex = this.searchCampaignList.findIndex(c => c.id === campaignId);
    this.searchCampaignList.splice(deletedCampaignIndex, 1);
    this.campaignService.deleteCampaign(campaignId).subscribe((res: any) => {
      this.triggerSearch();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: this.campaignToDelete.id,
        name: this.campaignToDelete.name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.DELETE,
        source: ActionSource.PAGE,
        campaignId: campaignId
      }, undefined, {
        type: ActivePages.CAMPAIGN_OVERVIEW
      });
      this.campaignToDelete = null;
      this.currentCampaign = null;
    }, (error) => {
      // rollback delete campaign in previous position
      this.searchCampaignList.splice(deletedCampaignIndex, 0, this.campaignToDelete);
      // show error message
      this.errorMessage = error.error.message;
      this.modalService.open(this.alertErrorWhenAddInfluencerToCampaign, this.beforeClearErrorNotification.bind(this), true);
    });
  }

  private declineCampaign(campaignInfluencerId) {
    this.closeWarningDeleteICampaignPopup();
    const data = {
      accessLevel: 'influencer',
      id: campaignInfluencerId,
      status: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name,
    };
    this.influencerService.updateInfluencerCampaignStatus(data).subscribe((res: any) => {
      const currentInfluencer = this.userService.getInfluencerInfo();
      this.fetchCampaignBelongedToInfluencer(currentInfluencer.id);
    });
  }

  closeWarningDeleteICampaignPopup() {
    this.modalService.close();
  }

  beforeClearErrorNotification() {
    this.errorMessage = null;
  }

  private setupSearchSubcription(initialSearch: string): void {
    this.currentSearchValue = initialSearch;
    this._companyIdSubject = new Subject<number>();
    this._searchValueSubject = new BehaviorSubject<string>(initialSearch);

    this._searchSubscription = combineLatest([
      this._companyIdSubject = new Subject<number>(),
      this._searchValueSubject,
    ]).pipe(
    tap(() => {
      this.placeholderService.show(CommonConstant.CAMPAIGN_LIST_HOLDER);
      this.isSearching = true;
      this.isSearchResultEmpty = false;
    }),
    debounceTime(700),
    switchMap(([companyId, searchValue]) => {
      const campaignSubscriptions = [
        this.campaignService.searchCampaigns(companyId, this.isCampaignHistory, searchValue),
        this.userService.getNewEventFromLastTime(EventType.NEW_CAMPAIGN_POST, companyId, this.userService.lastViewedCampaignTime(),
          new EventFilter(EventFilterType.CAMPAIGN_ID))
      ];

      return forkJoin(campaignSubscriptions).pipe(
        tap(([data, newEvent]) => {
          if (data && data.campaigns) {
            const campaigns = data.campaigns;
            campaigns.map((camp) => {
              camp.numberOfPosts = camp.totalPost;
              camp.typeName = this.translate.instant(`campaigns.${camp.type}`);
              camp.key_search = camp.name.toLowerCase().replace(/[^a-z0-9]/g, '');
              camp.isFetchingKpi = true;
              // auto open campaign influencer list if already selected
              if (camp.id === this.selectedCampaignId) {
                camp.is_expanded = true;
              }
              // new posts
              const newPublishedPosts = newEvent ? newEvent.events.find(evt => evt.key === String(camp.id)) : null;
              camp.newPosts = newPublishedPosts ? newPublishedPosts.value : null;
            });
            this.campaignList = campaigns;
            this.searchCampaignList = campaigns;
            // If selectedCampaign existed in request params, update currentCampaign based on selectedCampaign
            // else currentCampaign is null
            this.currentCampaign = this.selectedCampaignId ? (campaigns || []).find(cpItem => cpItem.id === this.selectedCampaignId) : null;
            this.runFetchInfluencersOfCampaignSerial(this.campaignList);
            this.filterCampaigns();
            this.updateCurrentUrlQueryParams();

            // just show empty message and send mixpanel event when we have search value
            if (!StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
              this.isSearchResultEmpty = campaigns.length === 0;
              this.sendSearchMixPanelEvent(campaigns.length);
            }
          }
          this.placeholderService.hide(CommonConstant.CAMPAIGN_LIST_HOLDER);
          this.isSearching = false;
        }),
        catchError(error => {
          this.handleSearchError(error);
          return of(null);
        })
      );
    })
    ).subscribe();
  }

  private handleSearchError(error: Error): void {
    this.modalService.close();

    // Searched campaign has exceed influencer limit
    if (error && error instanceof HttpErrorResponse) {
      const data = error.error && error.error.data;

      if (data === 'influencer_exceeded') {
        this.errorMessage = this.translate.instant('campaigns.searched_campaign_exceed_influencer_limit');
        this.modalService.open(this.alertErrorWhenAddInfluencerToCampaign, null, true);
        return;
      }
    }

    // Load fail
    if (StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
      this.errorMessage = this.translate.instant('campaigns.api_load_fail');
      this.modalService.openInCenter(this._searchCampaignErrorDialog);
      return;
    }

    // Search fail
    this.errorMessage = this.translate.instant('campaigns.api_search_fail');
    this.modalService.openInCenter(this._searchCampaignErrorDialog);
    WebUtils.reportErrorToSentry('Campaign search failed.', error);
  }

  private sendSearchMixPanelEvent(searchResultCount: number): void {
    this.eventTracker.trackUserAction(
      UserActionType.ACTION,
      Page.CAMPAIGN,
      {
        type: TargetType.CAMPAIGN
      },
      {
        action: UserActionType.SEARCH,
        source: ActionSource.PAGE,
        actionDetails: ActionDetails.HANDLE_SEARCH,
        action_status: 'SUCCESS',
        action_status_details: searchResultCount
      },
      undefined,
      {
        type: this.isCampaignHistory ? ActivePages.CAMPAIGN_HISTORY : ActivePages.CAMPAIGN_OVERVIEW,
      });
  }

  private triggerSearch(): void {
    this._companyIdSubject.next(this.companyId);
  }

  public onRetrySearch(): void {
    this.modalService.close();
    this.triggerSearch();
  }

  public onCancelSearch(): void {
    this.modalService.close();

    // show empty results
    this.searchCampaignList = [];
    this.filterCampaigns();
    this.placeholderService.hide(CommonConstant.CAMPAIGN_LIST_HOLDER);
    this.isSearching = false;
  }

  onSearchChange(search) {
    this.currentSearchValue = search;
    if (this.enableInfluencerPlatform) {
      this.triggerClientSearch();
      return;
    }

    this._searchValueSubject.next(search);
  }

  private triggerClientSearch(): void {
    const search = this.currentSearchValue;
    if (search !== null && this.campaignList && this.campaignList.length > 0) {
      this.searchCampaignList.forEach((campaignItem) => campaignItem.is_expanded = false); // deselected campaign
      this.currentCampaign = null; // reset bottom bar info
      const term = search.toLowerCase().replace(/[^a-z0-9]/g, '');
      this.searchCampaignList = this.campaignList.filter((campaign) => campaign.key_search.match(term) !== null);
    }

    this.filterCampaigns();
  }

  reloadSelectedCampaign(campaignId: number) {
    if (this._campaignItems && campaignId) {
      const campaignToReload = this._campaignItems.find(x => x.campaign.id === campaignId);
      if (campaignToReload) {
        campaignToReload.reloadCampaign();
      }
    }
  }

  editSelectedCampaign() {
    if (!this.currentCampaign || !this.currentCampaign.id) {
      return false;
    }
    this.sendMixpanelEvent(this.currentCampaign.id, this.currentCampaign.name);
    this.router.navigateByUrl('/campaigns/' + this.currentCampaign.id);
  }

  newCampaign() {
    this.cacheService.disableCacheRemoving();
    this.router.navigateByUrl('/campaigns-add');
  }

  openAddInfluencer(campaign) {
    this.currentCampaign = campaign;
    this.showAddInfluencerToCampaigns();
  }

  openMeasurePage(campaign) {
    this.router.navigate(['measure'], { queryParams: {campaign_id: campaign.id} });
  }

  get deletedCampaignName() {
    return this.campaignToDelete ? this.campaignToDelete.name : '';
  }

  get campaignBreadcrumbRoot() {
    return this.isCampaignHistory ? this.translate.instant('campaigns.campaign_history') : this.translate.instant('campaigns.breadcumb_root');
  }

  get campaignreadcrumbSubtitle() {
    return this.isCampaignHistory ? this.translate.instant('campaigns.campaign_history_subtitle') : this.translate.instant('campaigns.breadcumd_subtitle');
  }

  filterCampaigns() {
    this.invitesCampaignList = (this.searchCampaignList || []).filter((x) => {
      return x.status === CampaignInfluencerStatus.NEW;
    });
    this.activesCampaignList = (this.searchCampaignList || []).filter((x) => {
      if (this.enableInfluencerPlatform) {
        return x.status !== CampaignInfluencerStatus.NEW && x.campaignType === CampaignInfluencerStatus.ACTIVE;
      }
      return x.status === CampaignInfluencerStatus.ACTIVE;
    });
    this.historiesCampaignList = (this.searchCampaignList || []).filter((x) => {
      return (x.status !== CampaignInfluencerStatus.NEW
      && x.status !== CampaignInfluencerStatus.ACTIVE) || x.campaignType === CampaignInfluencerStatus.ARCHIVED;
    });
  }

  goToCampaignHistory() {
    // disable caching removing,
    // to prevent reloading list when switching back and forth between active campaigns and campaign history.
    this.cacheService.enableCacheRemoving();
    return this.router.navigate(['campaigns', 'history'], {
      queryParams: {
        activeAccount: this.companyId
      }
    });
  }

  backToCampaignPage() {
    // disable caching removing,
    // to prevent reloading list when switching back and forth between active campaigns and campaign history.
    this.cacheService.enableCacheRemoving();
    return this.router.navigate(['campaigns'], {
      queryParams: {
        activeAccount: this.companyId
       }
    });
  }

  private sendMixpanelEvent(campaignId, campaignName) {
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN, {
      id: campaignId,
      name: campaignName,
      type: TargetType.CAMPAIGN
    });
  }

  get acceptBtnLabel() {
    if (this.enableInfluencerPlatform || this.isCampaignHistory) {
      return this.translate.instant('common.btn.delete_confirm_ok');
    } else {
      return this.translate.instant('common.btn.archive_confirm_ok');
    }
  }

  get acceptCancelLabel() {
    if (this.enableInfluencerPlatform || this.isCampaignHistory) {
      return this.translate.instant('common.btn.delete_campaign_cancel');
    } else {
      return this.translate.instant('common.btn.cancel');
    }
  }

  get warningDeleteCampaignMessage() {
    if (this.enableInfluencerPlatform || this.isCampaignHistory) {
      return this.translate.instant('campaigns.delete_warning_message', {
        campaignName: this.deletedCampaignName
      });
    } else {
      return this.translate.instant('campaigns.archive_warning_message');
    }
  }

  public goToCampaignDetails(campaignId: number): void {
    let goToCampaignDetailsQueryParams = {
      activeAccount: this.userService.getCompanyId(),
      selectedCampaign: campaignId
    } as any;

    if (!StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
      goToCampaignDetailsQueryParams = { ...goToCampaignDetailsQueryParams, search: this.currentSearchValue };
    }

    this.router.navigate(['campaigns', campaignId, 'influencer-list'], { queryParams: goToCampaignDetailsQueryParams });
  }

  private updateCurrentUrlQueryParams(): void {
    const queryParams = { ...this._originalQueryParams };

    if (StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
      queryParams.search = undefined;
    } else {
      Object.assign(queryParams, { search: this.currentSearchValue });
    }
    const baseRouteUrl = this.router.url.split('?')[0];
    const url = this.router.createUrlTree([baseRouteUrl], { queryParams }).toString();
    this._location.replaceState(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaigns.component.ts